import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';

function Providers() {
  const [providers, setProviders] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Nome',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Endereço',
      field: 'street',
      hideFilterIcon: true,
      render: (rowData) => <p>{showAdress(rowData.street, rowData.number)}</p>,
    },
    {
      title: 'Cidade',
      field: 'city',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Estado',
      field: 'uf',
      editable: 'never',
      hideFilterIcon: true,
    },
  ];

  // função para mostrar o endereço vázio caso não tenha sido preenchido
  function showAdress(street, number) {
    if (street && number) {
      return `${street}, ${number}`;
    }
    return 'Endereço não fornecido!';
  }
  // fechamento da função para mostrar o endereço vázio caso não tenha sido preenchido

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/providers');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setProviders(response.data);
          setOpenProgress(true);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    providers.map((provider) => (provider.id === newData.id
      ? tempData.push(newData)
      : tempData.push(provider)));
    setProviders(tempData);
  }
  return (
    <Table
      title="Fornecedores"
      route="/providers/"
      routeAdd="/provider/"
      columns={columns}
      data={providers}
      setData={setData}
      dataLoaded={openProgress}
    />
  );
}

export default Providers;
